<template>
    <!-- お知らせ確認画面 -->
    <v-form ref="p2Form" v-model="p2Form" lazy-validation>
        <v-container>
            <v-card class="gridlist1" flat>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-form ref="tableForm" v-model="tableForm" lazy-validation v-if="tableRefresh">
                                <ryou-table ref="ryouTable" :rowKey="rowKey" :headers="headers" :url="url"
                                    :uploadFile="uploadFile" :businessKey="businessKey" :dummy="false" :height="height">
                                </ryou-table>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
    </v-form>
</template>

<script>
    import RyouTable from "@/components/table/RyouTable.vue";
    import { RyouTableMixins } from "@/mixins/RyouTableMixins";
    import fileDownload from "js-file-download";

    export default {
        name: "NoticeInformationRegistration",
        mixins: [RyouTableMixins],
        components: {
            RyouTable
        },
        mounted() {
            this.$refs.ryouTable.$on("doHandleIcon", this.doHandleIcon);
        },
        data() {
            return {
                p2Form: true,
                inputRulesFile: [],
                valid: true,
                search: "",
                rowKey: "rowIndex",
                businessKey: "info_seq_no",
                tableRefresh: true,
                tableForm: true,
                idFilterValue: "",
                chosenFile: null,
                height: 360,
                headers: [
                    {
                        text: "発行日",
                        class: "blue lighten-2 title",
                        value: "show_date",
                        align: "left",
                        width: "15%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "お知らせ",
                        class: "blue lighten-2 title",
                        value: "title",
                        width: "20%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "内容",
                        class: "blue lighten-2 title",
                        value: "message",
                        align: "left",
                        width: "35%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "添付ファイル",
                        class: "blue lighten-2 title",
                        value: "tmp_file",
                        type: "file",
                        width: "15%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "確認",
                        //class: "blue lighten-2 title",
                        class:"blue lighten-2 title",
                        value: "icon",
                        type: "icon",
                        align: "center",
                        sortable: false,
                        groupable: false
                    },
                    {
                        text: "",
                        value: "info_seq_no",
                        width: "0.1%",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                        filter: this.bgFilter
                    },
                    {
                        text: "",
                        value: "user_id",
                        width: "0.1%",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                        filter: this.bgFilter
                    }
                ],

                types: ["success", "error", "warning", "info", "default"],

                url: {
                    list: "/noticeConfirmation/noticeConfirmationGet" + "/" + this.$store.getters.getUserId,
                    update: "/NoticeConfirmation/noticeInformationUpdate",
                },
            };
        },
        created() {
        },
        watch: {
        },
        methods: {
            doHandleIcon(record) {

                if (record.icon == "red") {
                    let updateParams = {
                        user_id: this.$store.getters.getUserId,
                        info_seq_no: record.info_seq_no,
                    };
                    this.putRequest("/NoticeConfirmation/noticeConfirmationUpdate", updateParams, this.$store.getters.getUserToken).then((resp) => {
                        //画面表示
                        if (resp.success) {
                            this.$refs.ryouTable.loadData();
                        }
                    });
                }

                setTimeout(() => {
                    return;
                }, 100);
            },
            uploadFile(tmp_file, item) {

                if (item.icon == "red") {
                    let updateParams = {
                        user_id: this.$store.getters.getUserId,
                        info_seq_no: item.info_seq_no,
                    };
                    this.putRequest("/NoticeConfirmation/noticeConfirmationUpdate", updateParams, this.$store.getters.getUserToken).then((resp) => {

                        //ファイルパスは戻り
                        if (resp.success) {
                            this.$refs.ryouTable.loadData();

                            let streamParams = {
                                fileName: item.tmp_file,
                            };

                            //PDFはダウンロード
                            this.getStreamRequest('/noticeConfirmation/tmpFileDownload', streamParams, this.$store.getters.getUserToken).then(res => {
                                const blob = new Blob([res], { type: 'application/octet-stream;charset=utf-8' });
                                return fileDownload(blob, item.tmp_file);
                            }).catch(function (error) {
                                console.log(error);
                            });
                        }
                    });
                }
                else {
                    let streamParams = {
                        fileName: item.tmp_file,
                    };

                    //PDFはダウンロード
                    this.getStreamRequest('/noticeConfirmation/tmpFileDownload', streamParams, this.$store.getters.getUserToken).then(res => {
                        const blob = new Blob([res], { type: 'application/octet-stream;charset=utf-8' });
                        return fileDownload(blob, item.tmp_file);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            }
        },
        computed: {
        },
    };
</script>

<style>
    .gridlist1 {
        outline: 0px solid rgb(147, 179, 204);
        padding-top: 100px;
        padding-bottom: 0px;
    }
    .v-data-table {
        white-space: pre-line;
    }
    /*.v-data-table__mobile-row__cell {
        margin-left:3px;
        margin-right:auto;
    }*/
</style>
